import { render, staticRenderFns } from "./base-display-text.vue?vue&type=template&id=5e93814d&scoped=true"
import script from "./base-display-text.vue?vue&type=script&setup=true&lang=js"
export * from "./base-display-text.vue?vue&type=script&setup=true&lang=js"
import style0 from "./base-display-text.vue?vue&type=style&index=0&id=5e93814d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e93814d",
  null
  
)

export default component.exports